<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.14</b> - Исправления ИИ и багов, баланс игры</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Таверна: Снова увеличены пороги peanut для поддержания/улучшения</li>
      <li>
        Баланс:
        <ul>
          <li>
            - Скорректированы стоимости ОД/МС Молния
            <ul>
              <li class="pl-4">* стоимость ОД: <code>25</code> --> <code>40 - Уровень</code></li>
              <li class="pl-4">
                * стоимость МС: <code>50 + Уровень*4</code> -->
                <code>30 + Уровень*3</code>
              </li>
            </ul>
          </li>
          <li>
            - Скорректирована стоимость МС Призыв дворфа/Эльф/Фея:
            <code>100 + Уровень*40</code> --> <code>150 + Уровень*25</code>
          </li>
          <li>
            - Увеличена стоимость ОД Натиск богов: <code>10</code> -->
            <code>40 - Уровень</code>
          </li>
          <li>- Дворфы: удалён Блок щитом и добавлен Мощный удар</li>
          <li>
            - Отбрасывание Мощный удар уменьшено: <code>2 + Уровень*( Си/80 )</code> -->
            <code>1 + Уровень*( Си/120 )</code>
          </li>
        </ul>
      </li>
      <li>
        ИИ
        <ul>
          <li>
            - Исправлен баг, иногда заставлявший юнитов действовать до того, как был рассчитан результат предыдущей
            способности (например, стрельба стрелами по мёртвым целям, двойное применение
            CC).
          </li>
          <li>
            - Исправлены несколько багов, иногда заставлявших юнитов бегать туда-сюда бесцельно
          </li>
          <li>- В PvP дерево Interference теперь нацеливается только на вражеских героев</li>
          <li>
            - Только в Пещеры способности DoT будут распределяться равномерно. В PvP они теперь
            будут фокусироваться на одной героической цели.
          </li>
          <li>
            - Лучники больше не должны атаковать в ближнем бою соседних врагов, когда у них есть
            возможность отступить и стрелять
          </li>
          <li>- Танки больше не будут нацеливаться на оглушённых врагов с Насмешка</li>
          <li>- Увеличены шансы для юнитов DPS Close использовать Небесный молот и Мощный удар</li>
          <li>
            - Юниты Support теперь считают группы из 2+ союзников (вместо 3) "скоплением" для
            AoE лечения
          </li>
          <li>- Юниты больше не будут использовать Адреналин в страхе</li>
        </ul>
      </li>
      <li>Исправлены баги, препятствующие использованию Опыт Potions / Candles из инвентаря героя</li>
      <li>Исправлен баг, иногда не позволявший появляться куклам призванных юнитов</li>
      <li>Добавлены звуковые эффекты для Режущая стрела и Тупоконечная стрела</li>
      <li>Изменена отрисовка для испуг, ярость, Дорога в никуда, Заражение разума</li>
    </ul>
  </div>
</template>
